import { Dialog } from '@base-ui/react/dialog';
import { useRef } from 'react';

import { Button } from './button';

import type { ReactNode } from 'react';

export function ConfirmationDialog({
  open,
  title,
  children,
  confirmLabel,
  cancelLabel,
  busy = false,
  confirmDisabled = false,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  busy?: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const cancel = useRef<HTMLButtonElement>(null);
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(next) => {
        if (!next && !busy) onCancel();
      }}
    >
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-50 bg-[color-mix(in_oklab,var(--fg)_28%,transparent)] backdrop-blur-[2px]" />
        <Dialog.Popup
          initialFocus={cancel}
          className="border-line bg-canvas text-fg fixed left-1/2 top-1/2 z-50 max-h-[85dvh] w-[min(92vw,30rem)] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-xl border p-6 shadow-xl outline-none"
        >
          <Dialog.Title className="text-lg font-semibold tracking-tight">{title}</Dialog.Title>
          <Dialog.Description render={<div />} className="text-fg-muted mt-3 text-sm leading-6">
            {children}
          </Dialog.Description>
          <div className="mt-6 flex flex-wrap justify-end gap-2">
            <Button
              ref={cancel}
              type="button"
              variant="secondary"
              disabled={busy}
              onClick={onCancel}
            >
              {cancelLabel}
            </Button>
            <Button type="button" loading={busy} disabled={confirmDisabled} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
